import React from 'react';
import {createRoot} from 'react-dom/client';
import {App} from './App';
import type {Settings} from './api';
import './style.css';
for(const element of document.querySelectorAll<HTMLElement>('[data-cr-design-lab]')) {
  try {const settings=JSON.parse(element.dataset.crDesignLab!) as Settings;createRoot(element).render(<App settings={settings}/>);}
  catch {element.textContent='The designer could not load. Please contact the store.';}
}
